module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', [_vm._v("Author’s note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-p"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("1. LANDSCAPE WITH CATTLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landscape with Cattle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Hind’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Straw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schoolmates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barefoot Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playing the Milkmaid in the Hameau de la Reine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trawlerman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anatomical Model of the Cow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days of Whitewash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shearing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scythe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hedgecutter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days Left Till Harvest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvest Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvest Wake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hireling’s Lullaby")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-p"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("2. Earthstruck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Earthstruck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rough Sonnet from the Blacksmith’s Son")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gamekeeper’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tenderness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Smell of the Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At First Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Judge of Horse Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Missing the Harvest Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Every Man his Own Cattle Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casting a Cow, Ringing a Bull")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Millimetres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warning Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shepherd’s Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robertson’s First Wake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MacIntyre’s Big Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing the Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gone Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Father’s Soil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-p"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("3. STEPPING STONES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stepping Stones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Course of the Locher Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Boots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Without an Epiphany from the Belly of a Whale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Market Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long Way Round")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Viewpoint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing in the Cows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Wife’s Whistle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Brother’s Cloud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Father’s Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gene Pool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atrial Fibrillation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aeolian Harp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing the Pipe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vespers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Fever")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planting Aspen Saplings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0